module.exports = __webpack_public_path__ + "assets/img/mecha-btn-77da9d0d.png";